import { render, staticRenderFns } from "./GBPhotoAlbumContentAlbum.vue?vue&type=template&id=3f9c57d3&"
import script from "./GBPhotoAlbumContentAlbum.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumContentAlbum.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumContentAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VIcon,VLayout,VToolbar,VToolbarTitle})
